import { FormatterService } from "@/domain/services";
import { Plan, PlanPrice } from "../../domain/entities";
import { PlanPriceResponse, PlanResponse } from "../dtos/responses";

export class PlanMapper {
  constructor(private readonly currencyFormatter: FormatterService) {}
  toDomain(response: PlanResponse): Plan {
    const prices: PlanPrice[] = response.prices.map((elem: PlanPriceResponse) =>
      this.toPlanPrice(elem),
    );

    return {
      id: response.id,
      slug: response.slug,
      title: response.title,
      features: response.features.split("|"),
      description: response.description,
      description_heading: response.description_heading,
      prices,
    };
  }

  toPlanPrice = (response: PlanPriceResponse): PlanPrice => {
    const pricesConfig: Record<string, any> = {
      month: {
        title: "Plano mensal",
        description: "Para quem busca conhecer o app.",
        discount: null,
        value: `${this.currencyFormatter.format(response.price, 0)}/mês`,
      },
      semester: {
        title: "Plano semestral",
        description: "Plano mais popular.",
        discount: "32% OFF",
        value: `${this.currencyFormatter.format(response.price, 0)}/semestre`,
      },
      year: {
        title: "Plano anual",
        description: "12 meses pelo preço de 6.",
        discount: "45% OFF",
        value: `${this.currencyFormatter.format(response.price, 0)}/ano`,
      },
    };
    return {
      id: response.id,
      price_id: response.price_id,
      subscription_plan_id: response.subscription_plan_id,
      ...pricesConfig[response.frequency],
    };
  };
}
